
import { call, put } from 'redux-saga/effects'
import { AUTH_USER_CLAIM, AUTH_PUBLISHER_CLAIM } from 'piconetworks/pkg-endpoints'
import { picoAPIHelper } from 'piconetworks/pkg-network-middleware'

function* exchangeClaim({
    types,
    claim,
    scope,
    publisherId,
    team,
}) {
    try {
        const isPublisherScope = scope === 'publisher'

        const pathname = isPublisherScope ? AUTH_PUBLISHER_CLAIM() : AUTH_USER_CLAIM()

        let url = pathname

        if (!isPublisherScope) {
            url += `/${claim}`
        }

        if (team) {
            url += team ? `/${team}` : ''
        }
        const { data } = yield call(picoAPIHelper, {
            url,
            method: 'get',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                publisherid: publisherId,
            },
        })

        if (data) {
            yield put({
                type: types.EXCHANGE_CLAIM_SUCCESS,
                payload: data,
            })
        } else {
            throw new Error('unable to fetch article')
        }
    } catch (error) {
        yield put({
            type: types.EXCHANGE_CLAIM_ERROR,
            error: error?.message || 'GET_ARTICLE_ERROR',
        })
    }
}

export default exchangeClaim
